/*
 * @Author: 丨小小风离丨
 * @Date: 2024-01-03 20:11:01
 * @LastEditTime: 2025-01-07 16:53:04
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\teachins\index.tsx
 * @Description: 招生计划列表页
 */
import LabelNone from '@/components/label_none';
import { CommmonGet, CommmonPost } from '@/util/network/api';
import { Spin, message } from 'antd';
import { LgPopLayer } from 'lancoo-web-ui';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { selectUserId, setLoginShow } from '../../store/reducers/userInfo';
import { OptionFunContext } from './data';
import { genderList, typeList } from './data';
import './index.scss';
import RegisterPop from './list/registerPop';
import TeachinList from './list/teachinsList';

const Teachins = () => {

  const planYear = null

  const service = {
    list: '/portal/teachIn',
    applyTeachIn: 'portal/homepage/applyTeachIn'
  }

  const registerRef = useRef<any>(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const userId = useSelector(selectUserId);

  // 刷新
  const [isloading, setIsloading] = useState<boolean>(false);
  const [onceload, setOnceload] = useState<boolean>(false);
  const [refreshKey, setRefreshKey] = useState<number>(0);
  // 表格
  const [list, setList] = useState<any[]>([]);

  // 登记弹窗
  const [popFlag, setPopFlag] = useState<boolean>(false);
  const [popDetailsFlag, setPopDetailsFlag] = useState<boolean>(false);
  const [popData, setPopData] = useState<any>({});

  const optionFun = {
    checkPlan: (item: any) => {
      window.scrollTo(0, 0);
      navigate(`/teachins/details?id=${item.id}`);
    },
    enroll: (item: any) => {
      if (!userId) {
        dispatch(setLoginShow(true));
        return
      } else {
        setPopDetailsFlag(item?.registered);
        setPopFlag(true);
        setPopData(item);
      }
    }
  }

  const getList = () => {
    setIsloading(true);
    CommmonGet(service.list, { pageIndex: 1, pageSize: 20000, planYear }).then((res: any) => {
      setList(res.data?.pageList || []);
    }).catch(() => {
    }).finally(() => {
      setIsloading(false);
      setOnceload(true);
    });
  };
  useEffect(() => {
    if (pathname === '/teachins') {
      getList();
    }
  }, [pathname]);

  return (
    <>
      {pathname === '/teachins' && <div className="teachins">
        <Spin spinning={isloading} className='wjz_spin_div'>
          {onceload ?
            list?.length !== 0 ?
              <TeachinList list={list} optionFun={optionFun} /> : <LabelNone tips="暂无宣讲会" search={false} /> :
            <div></div>
          }
        </Spin>
      </div>}

      <OptionFunContext.Provider value={optionFun}>
        <Outlet key={refreshKey} />
      </OptionFunContext.Provider>

      {/* 新增弹窗 */}
      <LgPopLayer
        className={`wjz_pop_center ${popDetailsFlag ? 'wjz_pop_cancelNone' : ''}`}
        title={popDetailsFlag ? '登记信息' : "信息登记"}
        isOpen={popFlag}
        isCoverLayerClickClose={false}
        onShowLayer={(value: boolean, type: string) => {
          if (type === "onConfirm" && !popDetailsFlag) {
            const formOption = registerRef.current.form
            formOption.validateFields().then((values) => {
              registerRef.current.setIsloading(true);
              let itemDate = formOption.getFieldsValue();
              let data = {
                teachInId: popData.id,
                avatarId: itemDate.avatarId,
                name: itemDate.name,
                gender: genderList.find(ele => ele.text === itemDate.gender).Info,
                idCard: itemDate.idCard,
                type: typeList.find(ele => ele.text === itemDate.type).Info,
                phone: itemDate.phone,
                smsCode: itemDate.code
              }
              CommmonPost(service.applyTeachIn, data).then(res => {
                message.success("提交成功");
                setPopFlag(false);
                formOption.resetFields();
                if (pathname === '/teachins') {
                  getList();
                } else {
                  setRefreshKey(refreshKey + 1);
                }
              }).catch((error) => {
                message.error(error.message || error.msg || "提交失败");
              }).finally(() => {
                registerRef.current.setIsloading(false);
              })
            }).catch((error) => {
              console.log(error);
            })
          } else {
            setPopFlag(false);
          }
        }}
        width={popDetailsFlag ? 550 : 670}
        height={popDetailsFlag ? 420 : 535}
        scrollViewPosition={'Out'}
        isShowBottom={popDetailsFlag ? false : true}
      >
        <>
          {popFlag &&
            <RegisterPop
              ref={registerRef}
              popData={popData}
              popDetailsFlag={popDetailsFlag}
            />}
        </>
      </LgPopLayer>
    </>
  )
}

export default Teachins
